/**
 * BannerTypingIA — Item 267 UX target client-side.
 *
 * Banner discreto "Lume está digitando…" exibido enquanto IA prepara
 * resposta (modo H_c). Some quando `ai.typing.stopped` chega (natural ou
 * paused-by-client).
 */
export function BannerTypingIA({ visible }: { visible: boolean }): JSX.Element | null {
  if (!visible) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        color: 'var(--lume-muted)',
        fontSize: '13px',
        fontStyle: 'italic',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          gap: '3px',
        }}
      >
        <Dot delay={0} />
        <Dot delay={150} />
        <Dot delay={300} />
      </span>
      <span>Lume está digitando…</span>
    </div>
  );
}

function Dot({ delay }: { delay: number }): JSX.Element {
  return (
    <span
      style={{
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        background: 'var(--lume-muted)',
        animation: `lume-typing-pulse 1s ease-in-out ${String(delay)}ms infinite`,
      }}
    />
  );
}

// Keyframes inline via <style> global (uma vez).
const STYLE_ID = 'lume-typing-keyframes';
if (typeof document !== 'undefined' && document.getElementById(STYLE_ID) === null) {
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `@keyframes lume-typing-pulse {
    0%, 60%, 100% { opacity: 0.3; transform: scale(0.85); }
    30% { opacity: 1; transform: scale(1); }
  }`;
  document.head.appendChild(style);
}
